<template>
    <div>
        <!-- 配装器 -->
        <el-dialog title="凌雪阁配装器" ref="peiZhuangDialogRef" :visible.sync="peiZhuangDialog" width="1600px"
            custom-class="peiZhuangDialog" @open="peiZhuangDialogOpen()">
            <div style="" class='peiZhuangDialogBody'>
                <div style="border-radius: 10px;display: flex;padding: 5px">
                    <el-select v-model="programme.selectProgramme" placeholder="请选择" style="width: 300px;"
                        @change="changeProgramme">
                        <el-option v-for="programme in programme.programmeList" :key="programme.name"
                            :label="programme.name" :value="programme.name">
                        </el-option>
                    </el-select>
                    <el-button type="primary" @click="openProgrammeAddDialog" style="margin-left: 20px">新增方案</el-button>
                    <el-button type="primary" @click="() => {
                        this.deleteProgramme();
                    }" style="margin-left: 10px">删除方案</el-button>
                    <el-button type="primary" @click="openPeiZhuangImportDialog" style="margin-left: 20px"
                        data-v-step="1">装备导入</el-button>
                </div>

                <div style="display: flex;margin-bottom: 10px;" class="peiZhuangDialogMain">
                    <div style="width: 1250px;border:1px solid;border-radius: 10px;margin-right: 10px;"
                        class="peiZhuangDialogEquip">
                        <!-- 工具栏 -->
                        <div class="peiZhuangLine"
                            style="border-bottom: 1px solid #ccc;display: flex;height: 60px;padding-bottom: 5px;margin-top: 5px;">
                            <div style="float: right;width:50%;display: flex;justify-content: flex-start;">
                                <div class="peiZhuangUtilItem" style="justify-content: flex-start;">
                                    <el-popconfirm confirm-button-text='确认' cancel-button-text='取消' icon="el-icon-info"
                                        icon-color="red" title="推荐配装会清空你本地的方案，是否确认？" @confirm="recommendPeiZhuang()">
                                        <el-button slot="reference" round class="peiZhuangUtilButton" >推荐配装</el-button>
                                    </el-popconfirm>
                                </div>

                                <div class="peiZhuangUtilItem" style="justify-content: flex-start;">
                                    <el-button v-if="!peiZhuang.utils.autoComputeCheck"
                                        @click="manualComputePeiZhuangAttribute()" round class="peiZhuangUtilButton"
                                        style="background-color:#a33e16;">手动计算</el-button>
                                    <el-tooltip class="item" effect="dark" content="取消勾选后更换装备不再会立即计算收益"
                                        placement="top-start">
                                        <el-checkbox v-model="peiZhuang.utils.autoComputeCheck">DPS自动计算</el-checkbox>
                                    </el-tooltip>
                                    <el-tooltip class="item" effect="dark" content="选择该选项之后会自动对比装备数据，但是会消耗性能"
                                        placement="top-start">
                                        <el-checkbox v-model="peiZhuang.utils.autoContrast" @change="(check) => {
                                            // 一次加载所有的太离谱了做成一个开关 点谁统计谁
                                            // if(check)
                                            // contrastAllEquipmentOption();
                                        }">智能对比</el-checkbox>
                                    </el-tooltip>

                                </div>
                            </div>
                            <div style="float: right;width:50%;display: flex;justify-content: flex-end">
                                <div class="peiZhuangUtilItem" style="justify-content: flex-end;">
                                    <el-button @click="autoDiamond()" round class="peiZhuangUtilButton">一键镶嵌</el-button>
                                    <el-select v-model="peiZhuang.utils.diamondLevel" placeholder="请选择"
                                        class="peiZhuangUtilSelect">
                                        <el-option v-for="item in peiZhuang.utils.diamondLevelOption" :key="item"
                                            :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="peiZhuangUtilItem">
                                    <el-button @click="autoStrength()" round
                                        class="peiZhuangUtilButton">一键精炼</el-button>
                                    <el-select v-model="peiZhuang.utils.strengthLevel" placeholder="请选择"
                                        class="peiZhuangUtilSelect">
                                        <el-option v-for="item in peiZhuang.utils.strengthLevelOption" :key="item"
                                            :label="item" :value="item">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>

                        <div class="peiZhuangLine"
                            style="border-bottom: 1px solid #ccc;display: flex;height: 50px;padding-bottom: 5px;margin-top: 5px;margin-bottom: 5px;justify-content: center;">
                            <div style="width: 70px;">
                                <el-input v-model="peiZhuang.utils.filter.userSelectLevel[0]" @change="changeFilter"></el-input>
                            </div>
                            <div style="width: 40%;margin-left: 20px;margin-right: 20px;">
                                <el-slider v-model="peiZhuang.utils.filter.userSelectLevel" range :key="peiZhuang.utils.filter.userSelectLevelKey"
                                    :min="peiZhuang.utils.filter.minLevel" :max="peiZhuang.utils.filter.maxLevel" :step="50">
                                </el-slider>
                            </div>
                            <div style="width: 70px;">
                                <el-input v-model="peiZhuang.utils.filter.userSelectLevel[1]" @change="changeFilter"></el-input>
                            </div>
                            <el-checkbox v-model="peiZhuang.utils.filter.pve">pve</el-checkbox>
                            <el-checkbox v-model="peiZhuang.utils.filter.pvx">pvx</el-checkbox>
                            <el-checkbox v-model="peiZhuang.utils.filter.pvp">pvp</el-checkbox>
                        </div>


                        <!-- 帽子 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                帽子:
                            </div>
                            <el-select class="equipSelect" id="HatEquipSelect" v-model="peiZhuang.hat.id" filterable
                                clearable @click.native="() => {
                                    contrastHatDps();
                                }" @clear="peiZhuangClear(peiZhuang.hat)">
                                <el-option v-for="equip in peiZhuang.hat.select" :key="equip.id" :value="equip.id"
                                    @click.native="() => {
                                        // peiZhuangInitEquipById(equip.id, peiZhuang.hat.select, peiZhuang.hat);
                                        peiZhuangInitEquip(peiZhuang.hat, equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastHatDps();
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.hat.strengthLevel" class="strengthSelect" filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.hat.value.maxStrengthLevel == null ? 0 : peiZhuang.hat.value.maxStrengthLevel,
                                            peiZhuang.hat.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.hat.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.hat.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.hat.enchant1.id" class="enchantSelect1" clearable @clear="() => {
                                    peiZhuang.hat.enchant1.value = null;
                                    autoComputePeiZhuangAttribute();
                                }" @click.native="() => {
                                    contrastHatEnhanceDps();
                                }" filterable>
                                    <el-option v-for="enchant in peiZhuang.hat.enchant1.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.attributeName" @click.native="() => {
                                            peiZhuang.hat.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastHatEnhanceDps()
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 大附魔 -->
                            <div class="enchant2" style="display: flex;">
                                <div class="peiZhuangLabel">大附魔:</div>
                                <el-select v-model="peiZhuang.hat.enchant2.id" class="enchantSelect2" clearable
                                    @clear="autoComputePeiZhuangAttribute()" @click.native="() => {
                                        contrastHatEnchantDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.hat.enchant2.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.name" @click.native="() => {
                                            peiZhuang.hat.enchant2.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastHatEnchantDps();
                                        }">
                                        <PeiZhuangEnchant2 :enchant="enchant"> </PeiZhuangEnchant2>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <!-- 上衣 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                上衣:
                            </div>
                            <el-select class="equipSelect" id="JacketEquipSelect" v-model="peiZhuang.jacket.id"
                                filterable clearable @click.native="() => {
                                    contrastJacketDps();
                                }" @clear="peiZhuangClear(peiZhuang.jacket)">
                                <el-option v-for="equip in peiZhuang.jacket.select" :key="equip.id" :value="equip.id"
                                    @click.native="() => {
                                        peiZhuangInitEquip(peiZhuang.jacket, equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastJacketDps();
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.jacket.strengthLevel" class="strengthSelect" filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.jacket.value.maxStrengthLevel == null ? 0 : peiZhuang.jacket.value.maxStrengthLevel,
                                            peiZhuang.jacket.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.jacket.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.jacket.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.jacket.enchant1.id" class="enchantSelect1" clearable
                                    @clear="() => {
                                        peiZhuang.jacket.enchant1.value = null;
                                        autoComputePeiZhuangAttribute();
                                    }" @click.native="() => {
                                        contrastJacketEnhanceDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.jacket.enchant1.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.attributeName" @click.native="() => {
                                            peiZhuang.jacket.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastJacketEnhanceDps();
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 大附魔 -->
                            <div class="enchant2" style="display: flex;">
                                <div class="peiZhuangLabel">大附魔:</div>
                                <el-select v-model="peiZhuang.jacket.enchant2.id" class="enchantSelect2" clearable
                                    @clear="autoComputePeiZhuangAttribute()" @click.native="() => {
                                        contrastJacketEnchantDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.jacket.enchant2.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.name" @click.native="() => {
                                            peiZhuang.jacket.enchant2.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastJacketEnchantDps();
                                        }">
                                        <PeiZhuangEnchant2 :enchant="enchant"> </PeiZhuangEnchant2>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <!-- 腰带 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                腰带:
                            </div>
                            <el-select class="equipSelect" id="BeltEquipSelect" v-model="peiZhuang.belt.id" filterable
                                clearable @click.native="() => {
                                    contrastBeltDps();
                                }" @clear="peiZhuangClear(peiZhuang.belt)">
                                <el-option v-for="equip in peiZhuang.belt.select" :key="equip.id" :value="equip.id"
                                    @click.native="() => {
                                        peiZhuangInitEquip(peiZhuang.belt, equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastBeltDps();
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.belt.strengthLevel" class="strengthSelect" filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.belt.value.maxStrengthLevel == null ? 0 : peiZhuang.belt.value.maxStrengthLevel,
                                            peiZhuang.belt.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.belt.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.belt.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.belt.enchant1.id" class="enchantSelect1" clearable @clear="() => {
                                    peiZhuang.belt.enchant1.value = null;
                                    autoComputePeiZhuangAttribute();
                                }" @click.native="() => {
                                    contrastBeltEnhanceDps();
                                }" filterable>
                                    <el-option v-for="enchant in peiZhuang.belt.enchant1.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.attributeName" @click.native="() => {
                                            peiZhuang.belt.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastBeltEnhanceDps();
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 大附魔 -->
                            <div class="enchant2" style="display: flex;">
                                <div class="peiZhuangLabel">大附魔:</div>
                                <el-select v-model="peiZhuang.belt.enchant2.id" class="enchantSelect2" clearable
                                    @clear="autoComputePeiZhuangAttribute()" @click.native="() => {
                                        contrastBeltEnchantDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.belt.enchant2.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.name" @click.native="() => {
                                            peiZhuang.belt.enchant2.value = enchant;
                                            contrastBeltEnchantDps();
                                            autoComputePeiZhuangAttribute();
                                        }">
                                        <PeiZhuangEnchant2 :enchant="enchant"> </PeiZhuangEnchant2>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <!-- 护腕 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                护腕:
                            </div>
                            <el-select class="equipSelect" id="ShoesEquipSelect" v-model="peiZhuang.wrist.id" filterable
                                clearable @click.native="() => {
                                    contrastWristDps();
                                }" @clear="peiZhuangClear(peiZhuang.wrist)">
                                <el-option v-for="equip in peiZhuang.wrist.select" :key="equip.id" :value="equip.id"
                                    @click.native="() => {
                                        peiZhuangInitEquip(peiZhuang.wrist, equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastWristDps();
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.wrist.strengthLevel" class="strengthSelect" filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.wrist.value.maxStrengthLevel == null ? 0 : peiZhuang.wrist.value.maxStrengthLevel,
                                            peiZhuang.wrist.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.wrist.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.wrist.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.wrist.enchant1.id" class="enchantSelect1" clearable
                                    @clear="() => {
                                        peiZhuang.wrist.enchant1.value = null;
                                        autoComputePeiZhuangAttribute();
                                    }" @click.native="() => {
                                        contrastWristEnhanceDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.wrist.enchant1.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.attributeName" @click.native="() => {
                                            peiZhuang.wrist.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastWristEnhanceDps();
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 大附魔 -->
                            <div class="enchant2" style="display: flex;">
                                <div class="peiZhuangLabel">大附魔:</div>
                                <el-select v-model="peiZhuang.wrist.enchant2.id" class="enchantSelect2" clearable
                                    @clear="autoComputePeiZhuangAttribute()" @click.native="() => {
                                        contrastWristEnchantDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.wrist.enchant2.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.name" @click.native="() => {
                                            peiZhuang.wrist.enchant2.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastWristEnchantDps();
                                        }">
                                        <PeiZhuangEnchant2 :enchant="enchant"> </PeiZhuangEnchant2>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <!-- 裤子 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                裤子:
                            </div>
                            <el-select class="equipSelect" id="BottomsEquipSelect" v-model="peiZhuang.bottoms.id"
                                filterable clearable @click.native="() => {
                                    contrastBottomsDps();
                                }" @clear="peiZhuangClear(peiZhuang.bottoms)">
                                <el-option v-for="equip in peiZhuang.bottoms.select" :key="equip.id" :value="equip.id"
                                    @click.native="() => {
                                        peiZhuangInitEquip(peiZhuang.bottoms, equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastBottomsDps();
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.bottoms.strengthLevel" class="strengthSelect" filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.bottoms.value.maxStrengthLevel == null ? 0 : peiZhuang.bottoms.value.maxStrengthLevel,
                                            peiZhuang.bottoms.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.bottoms.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.bottoms.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.bottoms.enchant1.id" class="enchantSelect1" clearable
                                    @clear="() => {
                                        peiZhuang.bottoms.enchant1.value = null;
                                        autoComputePeiZhuangAttribute();
                                    }" @click.native="() => {
                                        contrastBottomsEnhanceDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.bottoms.enchant1.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.attributeName" @click.native="() => {
                                            peiZhuang.bottoms.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastBottomsEnhanceDps();
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>


                        <!-- 鞋子 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                鞋子:
                            </div>
                            <el-select class="equipSelect" id="ShoesEquipSelect" v-model="peiZhuang.shoes.id" filterable
                                clearable @click.native="() => {
                                    contrastShoesDps();
                                }" @clear="peiZhuangClear(peiZhuang.shoes)">
                                <el-option v-for="equip in peiZhuang.shoes.select" :key="equip.id" :value="equip.id"
                                    @click.native="() => {
                                        peiZhuangInitEquip(peiZhuang.shoes, equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastShoesDps();
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.shoes.strengthLevel" class="strengthSelect" filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.shoes.value.maxStrengthLevel == null ? 0 : peiZhuang.shoes.value.maxStrengthLevel,
                                            peiZhuang.shoes.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.shoes.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.shoes.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.shoes.enchant1.id" class="enchantSelect1" clearable
                                    @clear="() => {
                                        peiZhuang.shoes.enchant1.value = null;
                                        autoComputePeiZhuangAttribute();
                                    }" @click.native="() => {
                                        contrastShoesEnhanceDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.shoes.enchant1.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.attributeName" @click.native="() => {
                                            peiZhuang.shoes.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastShoesEnhanceDps();
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 大附魔 -->
                            <div class="enchant2" style="display: flex;">
                                <div class="peiZhuangLabel">大附魔:</div>
                                <el-select v-model="peiZhuang.shoes.enchant2.id" class="enchantSelect2" clearable
                                    @clear="autoComputePeiZhuangAttribute()" @click.native="() => {
                                        contrastShoesEnchantDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.shoes.enchant2.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.name" @click.native="() => {
                                            peiZhuang.shoes.enchant2.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastShoesEnchantDps();
                                        }">
                                        <PeiZhuangEnchant2 :enchant="enchant"> </PeiZhuangEnchant2>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <!-- 项链 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                项链:
                            </div>
                            <el-select class="equipSelect" id="NecklaceEquipSelect" v-model="peiZhuang.necklace.id"
                                filterable clearable @click.native="() => {
                                    contrastNecklaceDps();
                                }" @clear="peiZhuangClear(peiZhuang.necklace)">
                                <el-option v-for="equip in peiZhuang.necklace.select" :key="equip.id" :value="equip.id"
                                    @click.native="() => {
                                        peiZhuangInitEquip(peiZhuang.necklace, equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastNecklaceDps();
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.necklace.strengthLevel" class="strengthSelect" filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.necklace.value.maxStrengthLevel == null ? 0 : peiZhuang.necklace.value.maxStrengthLevel,
                                            peiZhuang.necklace.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.necklace.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.necklace.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.necklace.enchant1.id" class="enchantSelect1" clearable
                                    @clear="() => {
                                        peiZhuang.necklace.enchant1.value = null;
                                        autoComputePeiZhuangAttribute();
                                    }" @click.native="() => {
                                        contrastNecklaceEnhanceDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.necklace.enchant1.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.attributeName" @click.native="() => {
                                            peiZhuang.necklace.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastNecklaceEnhanceDps();
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <!-- 腰坠 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                腰坠:
                            </div>
                            <el-select class="equipSelect" id="PendantEquipSelect" v-model="peiZhuang.pendant.id"
                                filterable clearable @click.native="() => {
                                    contrastPendantDps();
                                }" @clear="peiZhuangClear(peiZhuang.pendant)">
                                <el-option v-for="equip in peiZhuang.pendant.select" :key="equip.id" :value="equip.id"
                                    @click.native="() => {
                                        peiZhuangInitEquip(peiZhuang.pendant, equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastPendantDps()
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.pendant.strengthLevel" class="strengthSelect" filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.pendant.value.maxStrengthLevel == null ? 0 : peiZhuang.pendant.value.maxStrengthLevel,
                                            peiZhuang.pendant.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.pendant.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.pendant.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.pendant.enchant1.id" class="enchantSelect1" clearable
                                    @clear="() => {
                                        peiZhuang.pendant.enchant1.value = null;
                                        autoComputePeiZhuangAttribute();
                                    }" @click.native="() => {
                                        contrastPendantEnhanceDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.pendant.enchant1.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.attributeName" @click.native="() => {
                                            peiZhuang.pendant.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastPendantEnhanceDps();
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <!-- 戒指 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                戒指:
                            </div>
                            <el-select class="equipSelect" id="Ring1EquipSelect" v-model="peiZhuang.ring1.id" filterable
                                clearable @click.native="() => {
                                    contrastRing1Dps();
                                }" @clear="peiZhuangClear(peiZhuang.ring1)">
                                <el-option v-for="equip in peiZhuang.ring1.select" :key="equip.id" :value="equip.id"
                                    @click.native="() => {
                                        peiZhuangInitEquip(peiZhuang.ring1, equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastRing1Dps();
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.ring1.strengthLevel" class="strengthSelect" filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.ring1.value.maxStrengthLevel == null ? 0 : peiZhuang.ring1.value.maxStrengthLevel,
                                            peiZhuang.ring1.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.ring1.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.ring1.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.ring1.enchant1.id" class="enchantSelect1" clearable
                                    @clear="() => {
                                        peiZhuang.ring1.enchant1.value = null;
                                        autoComputePeiZhuangAttribute();
                                    }" @click.native="() => {
                                        contrastRing1EnhanceDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.ring1.enchant1.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.attributeName" @click.native="() => {
                                            peiZhuang.ring1.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastRing1EnhanceDps();
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <!-- 戒指 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                戒指:
                            </div>
                            <el-select class="equipSelect" id="Ring2EquipSelect" v-model="peiZhuang.ring2.id" filterable
                                clearable @click.native="() => {
                                    contrastRing2Dps();
                                }" @clear="peiZhuangClear(peiZhuang.ring2)">
                                <el-option v-for="equip in peiZhuang.ring2.select" :key="equip.id" :value="equip.id"
                                    @click.native="() => {
                                        peiZhuangInitEquip(peiZhuang.ring2, equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastRing2Dps()
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.ring2.strengthLevel" class="strengthSelect" filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.ring2.value.maxStrengthLevel == null ? 0 : peiZhuang.ring2.value.maxStrengthLevel,
                                            peiZhuang.ring2.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.ring2.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.ring2.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.ring2.enchant1.id" class="enchantSelect1" clearable
                                    @clear="() => {
                                        peiZhuang.ring2.enchant1.value = null;
                                        autoComputePeiZhuangAttribute();
                                    }" @click.native="() => {
                                        contrastRing2EnhanceDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.ring2.enchant1.select" :key="enchant.id"
                                        :value="enchant.id" :label="enchant.attributeName" @click.native="() => {
                                            peiZhuang.ring2.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastRing2EnhanceDps();
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>


                        <!-- 暗器 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                暗器:
                            </div>
                            <el-select class="equipSelect" id="SecondaryWeaponEquipSelect"
                                v-model="peiZhuang.secondaryWeapon.id" filterable clearable @click.native="() => {
                                    contrastSecondaryWeaponDps();
                                }" @clear="peiZhuangClear(peiZhuang.secondaryWeapon)">
                                <el-option v-for="equip in peiZhuang.secondaryWeapon.select" :key="equip.id"
                                    :value="equip.id" @click.native="() => {
                                        peiZhuangInitEquip(peiZhuang.secondaryWeapon, equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastSecondaryWeaponDps()
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.secondaryWeapon.strengthLevel" class="strengthSelect"
                                    filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.secondaryWeapon.value.maxStrengthLevel == null ? 0 : peiZhuang.secondaryWeapon.value.maxStrengthLevel,
                                            peiZhuang.secondaryWeapon.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.secondaryWeapon.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.secondaryWeapon.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.secondaryWeapon.enchant1.id" class="enchantSelect1"
                                    clearable @clear="() => {
                                        peiZhuang.secondaryWeapon.enchant1.value = null;
                                        autoComputePeiZhuangAttribute();
                                    }" @click.native="() => {
                                        contrastSecondaryWeaponEnhanceDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.secondaryWeapon.enchant1.select"
                                        :key="enchant.id" :value="enchant.id" :label="enchant.attributeName"
                                        @click.native="() => {
                                            peiZhuang.secondaryWeapon.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastSecondaryWeaponEnhanceDps();
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <!-- 武器 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                武器:
                            </div>
                            <el-select class="equipSelect" id="PrimaryWeaponEquipSelect"
                                v-model="peiZhuang.primaryWeapon.id" filterable clearable @click.native="() => {
                                    contrastPrimaryWeaponDps();
                                }" @clear="peiZhuangClear(peiZhuang.primaryWeapon)">
                                <el-option v-for="equip in peiZhuang.primaryWeapon.select" :key="equip.id"
                                    :value="equip.id" @click.native="() => {
                                        peiZhuangInitEquip(peiZhuang.primaryWeapon, equip);
                                        changeLoopByEquip(equip);
                                        autoComputePeiZhuangAttribute();
                                        contrastPrimaryWeaponDps();
                                    }" :label="equip.level + ' ' + equip.name" v-show="filterEquip(equip)">
                                    <PeiZhuangOption :equip="equip"></PeiZhuangOption>
                                </el-option>
                            </el-select>
                            <!-- 精炼等级 -->
                            <div class="strengthLevel" style="display: flex;">
                                <div class="peiZhuangLabel">
                                    精炼:
                                </div>
                                <el-select v-model="peiZhuang.primaryWeapon.strengthLevel" class="strengthSelect"
                                    filterable>
                                    <el-option v-for="level in peiZhuang.strengthLevelOption.slice(
                                        (peiZhuang.primaryWeapon.value.maxStrengthLevel == null ? 0 : peiZhuang.primaryWeapon.value.maxStrengthLevel,
                                            peiZhuang.primaryWeapon.value.maxStrengthLevel == null ? 8 : (8 - peiZhuang.primaryWeapon.value.maxStrengthLevel))
                                    )" :key="level" :value="level" :label="level"
                                        @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 镶嵌属性 -->
                            <div class="diamondAttribute"
                                v-for="equip in peiZhuang.primaryWeapon.value.equipOptionDiamondAttributeVoList"
                                style="display: flex;">
                                <div class="peiZhuangLabel">{{ equip.name }}:</div>
                                <el-select v-model="equip.diamondLevel" class="diamondSelect" filterable>
                                    <el-option v-for="level in peiZhuang.diamondLevelOption" :key="level" :value="level"
                                        :label="level" @click.native="autoComputePeiZhuangAttribute()">
                                    </el-option>
                                </el-select>
                            </div>
                            <!-- 小附魔 -->
                            <div class="enchant1" style="display: flex;">
                                <div class="peiZhuangLabel">小附魔:</div>
                                <el-select v-model="peiZhuang.primaryWeapon.enchant1.id" class="enchantSelect1"
                                    clearable @clear="() => {
                                        peiZhuang.primaryWeapon.enchant1.value = null;
                                        autoComputePeiZhuangAttribute();
                                    }" @click.native="() => {
                                        contrastPrimaryWeaponEnhanceDps();
                                    }" filterable>
                                    <el-option v-for="enchant in peiZhuang.primaryWeapon.enchant1.select"
                                        :key="enchant.id" :value="enchant.id" :label="enchant.attributeName"
                                        @click.native="() => {
                                            peiZhuang.primaryWeapon.enchant1.value = enchant;
                                            autoComputePeiZhuangAttribute();
                                            contrastPrimaryWeaponEnhanceDps();
                                        }">
                                        <PeiZhuangEnchant :enchant="enchant"> </PeiZhuangEnchant>
                                    </el-option>
                                </el-select>
                            </div>
                        </div>

                        <!-- 五彩石 -->
                        <div class="peiZhuangLine">
                            <div class="peiZhuangLabel">
                                五彩石:
                            </div>
                            <el-cascader v-model="peiZhuang.stone.stoneKey" :options="peiZhuang.stone.stoneTree"
                                @change="() => {
                                    peiZhuangInitStone(peiZhuang.stone.stoneKey[0], peiZhuang.stone.stoneKey[1], peiZhuang.stone.stoneKey[2], peiZhuang.stone.stoneKey[3]);
                                }" clearable>
                            </el-cascader>
                        </div>
                    </div>

                    <div style="width:350px;border:1px solid;border-radius: 10px;">
                        <div class="el-dialog-title" style="margin-top: 10px;">
                            属性区域
                        </div>
                        <div
                            style="margin-right:10px;margin-left:10px;height: 320px;border:1px solid;border-radius: 10px;">
                            <div class="peiZhuangAttributeLine">
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        装分
                                    </div>
                                    <div class="peiZhuangAttributeValue" >
                                        {{ this.sectBase.finalAttribute.nEquipScore }}
                                    </div>
                                </div>
                            </div>
                            <div class="peiZhuangAttributeLine">
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        体质
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ this.sectBase.finalAttribute.atVitalityBase }}
                                    </div>
                                </div>

                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        气血
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ this.sectBase.finalAttribute.atMaxLifeBase }}
                                    </div>
                                </div>
                            </div>
                            <div class="peiZhuangAttributeLine">
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        身法
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ this.sectBase.finalAttribute.atAgilityBase }}
                                    </div>
                                </div>
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        武器伤害
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ (this.sectBase.finalAttribute.atMeleeWeaponDamageBase * 2 +
                                            this.sectBase.finalAttribute.atMeleeWeaponDamageRand) / 2 }}
                                    </div>
                                </div>
                            </div>
                            <div class="peiZhuangAttributeLine">
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        基础攻击
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ this.sectBase.currentAttribute.atPhysicsAttackPowerBase }}
                                    </div>
                                </div>
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        最终攻击
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ this.sectBase.finalAttribute.atPhysicsAttackPowerBase }}
                                    </div>
                                </div>
                            </div>
                            <div class="peiZhuangAttributeLine">
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        会心
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ this.sectBase.finalAttribute.atPhysicsCriticalStrikeBaseRate }}%
                                    </div>
                                </div>
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        会心效果
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ this.sectBase.finalAttribute.atPhysicsCriticalDamagePowerBaseKiloNumRate }}%
                                    </div>
                                </div>
                            </div>
                            <div class="peiZhuangAttributeLine">
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        破防
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ this.sectBase.finalAttribute.atPhysicsOvercomePercent }}%
                                    </div>
                                </div>
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        无双
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ this.sectBase.finalAttribute.atStrainRate }}%
                                    </div>
                                </div>
                            </div>
                            <div class="peiZhuangAttributeLine">
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        破招
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ this.sectBase.finalAttribute.atSurplusValueBase }}
                                    </div>
                                </div>
                                <div class="peiZhuangAttributeItem">
                                    <div class="peiZhuangAttributeLabel">
                                        加速
                                    </div>
                                    <div class="peiZhuangAttributeValue">
                                        {{ this.sectBase.finalAttribute.atHasteBase }}
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div style="height: 250px;">
                            <div class="peiZhuangSetLine">
                                <div class="peiZhuangSetItem">
                                    <div class="peiZhuangSetLabel">
                                        技能增强：
                                    </div>
                                    <div class="peiZhuangSetTrueValue"
                                        v-if="sectBase.peiZhuang.specialEffects.atSetEquipmentRecipe.some(item => constant.skillAdditionList.includes(item))">
                                        开启
                                    </div>
                                    <div class="peiZhuangSetFalseValue"
                                        v-if="!sectBase.peiZhuang.specialEffects.atSetEquipmentRecipe.some(item => constant.skillAdditionList.includes(item))">
                                        关闭
                                    </div>
                                </div>
                                <div class="peiZhuangSetItem">
                                    <div class="peiZhuangSetLabel">
                                        双会套装：
                                    </div>
                                    <div class="peiZhuangSetTrueValue"
                                        v-if="sectBase.peiZhuang.specialEffects.equipSkill.includes(constant.criticalStrikeSkillId) || (sectBase.peiZhuang.specialEffects.setMap.get(constant.criticalStrikeSetId) >= 2)">
                                        开启
                                    </div>
                                    <div class="peiZhuangSetFalseValue"
                                        v-if="!sectBase.peiZhuang.specialEffects.equipSkill.includes(constant.criticalStrikeSkillId) && (!sectBase.peiZhuang.specialEffects.setMap.get(constant.criticalStrikeSetId) >= 2)">
                                        关闭
                                    </div>
                                </div>
                            </div>
                            <div class="peiZhuangSetLine">
                                <div class="peiZhuangSetItem">
                                    <div class="peiZhuangSetLabel">
                                        特效腰坠:
                                    </div>
                                    <div class="peiZhuangSetTrueValue"
                                        v-if="peiZhuang.show.showFTX">
                                        开启
                                    </div>
                                    <div class="peiZhuangSetFalseValue"
                                        v-if="!peiZhuang.show.showFTX">
                                        关闭
                                    </div>
                                </div>
                                <div class="peiZhuangSetItem">
                                    <div class="peiZhuangSetLabel">
                                        特效武器:
                                    </div>
                                    <div class="peiZhuangSetTrueValue"
                                        v-if="peiZhuang.show.showSTX">
                                        水特效
                                    </div>
                                    <div class="peiZhuangSetTrueValue"
                                        v-if="sectBase.peiZhuang.specialEffects.equipSkill.some(item => constant.qwzhSkillIdList.includes(item))">
                                        麒王逐魂
                                    </div>
                                    <div class="peiZhuangSetTrueValue"
                                        v-if="sectBase.peiZhuang.specialEffects.equipSkill.some(item => constant.cwTXSkillIdList.includes(item))">
                                        橙武
                                    </div>
                                    <div class="peiZhuangSetFalseValue"
                                        v-if="!peiZhuang.show.showSTX &&
                                            !sectBase.peiZhuang.specialEffects.equipSkill.some(item => constant.qwzhSkillIdList.includes(item)) &&
                                            !sectBase.peiZhuang.specialEffects.equipSkill.some(item => constant.cwTXSkillIdList.includes(item))">
                                        关闭
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style="border: 1px solid;border-radius: 10px;margin: 10px">
                            <div class="peiZhuangDpsLine">
                                <div class="peiZhuangDpsItem">
                                    <div class="peiZhuangDpsLabel">
                                        更新前DPS:
                                    </div>
                                    <div class="peiZhuangDpsTrueValue">
                                        {{ peiZhuang.dps.dpsOld }}
                                    </div>
                                </div>
                            </div>
                            <div class="peiZhuangDpsLine">
                                <div class="peiZhuangDpsItem">
                                    <div class="peiZhuangDpsLabel">
                                        更新后DPS:
                                    </div>
                                    <div class="peiZhuangDpsTrueValue"
                                        v-if="peiZhuang.dps.dpsNew >= peiZhuang.dps.dpsOld">
                                        {{ peiZhuang.dps.dpsNew }}
                                    </div>
                                    <div class="peiZhuangDpsFalseValue"
                                        v-if="peiZhuang.dps.dpsNew < peiZhuang.dps.dpsOld">
                                        {{ peiZhuang.dps.dpsNew }}
                                    </div>
                                </div>
                            </div>
                            <div class="peiZhuangDpsLine">
                                <div class="peiZhuangDpsItem">
                                    <div class="peiZhuangDpsLabel" v-if="peiZhuang.dps.dpsNew >= peiZhuang.dps.dpsOld">
                                        增加DPS:
                                    </div>
                                    <div class="peiZhuangDpsLabel" v-if="peiZhuang.dps.dpsNew < peiZhuang.dps.dpsOld">
                                        降低DPS:
                                    </div>
                                    <div class="peiZhuangDpsTrueValue"
                                        v-if="peiZhuang.dps.dpsNew >= peiZhuang.dps.dpsOld">
                                        {{ peiZhuang.dps.dpsNew - peiZhuang.dps.dpsOld }}
                                    </div>
                                    <div class="peiZhuangDpsFalseValue"
                                        v-if="peiZhuang.dps.dpsNew < peiZhuang.dps.dpsOld">
                                        {{ peiZhuang.dps.dpsOld - peiZhuang.dps.dpsNew }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                    <el-button @click="peiZhuangDialog = false">取 消</el-button>
                    <el-button type="primary" @click="confrim">确 定</el-button>
                </div>

        </el-dialog>
        <ProgrameAddDialog ref="programmeDialogRef" @confirm="addProgramme"> </ProgrameAddDialog>
        <PeiZhuangImportDialog ref="peiZhuangImportDialogRef" @moHeImportData="onMoHeImportData">
        </PeiZhuangImportDialog>
    </div>


</template>

<script>
import ProgrameAddDialog from "./ProgrammeAddDialog.vue"
import PeiZhuangOption from "./PeiZhuangOption.vue"
import PeiZhuangEnchant from "./PeiZhuangEnchant.vue"
import PeiZhuangEnchant2 from "./PeiZhuangEnchant2.vue"
import PeiZhuangImportDialog from "./import/PeiZhuangImportDialog.vue"
import { Constant } from "@/minixs/Constant"
import { Mixins } from "@/minixs/DuanYou"
import { RecommendPeiZhuang } from "@/minixs/RecommendPeiZhuang.js"
import { SectConstant } from "@/sect/SectConstant"
import * as copyUtils from "@/minixs/CopyUtils"
import { BaseSect } from "@/sect/BaseSect"
import * as jsonUtils from "@/utils/JsonUtils"
import * as dataApi from "@/api/DataApi"


export default {
    props: {
        sectProp: ''
    },
    components: { ProgrameAddDialog, PeiZhuangOption, PeiZhuangEnchant, PeiZhuangEnchant2, PeiZhuangImportDialog },
    mixins: [Constant, Mixins, RecommendPeiZhuang, SectConstant, BaseSect],
    data() {
        return {
            peiZhuangDialog: false,
            programme: {
                selectProgramme: "默认方案",
                programmeList: [{
                    name: "默认方案",
                }]
            },
            peiZhuang: {
                strengthLevelOption: ["8", "7", "6", "5", "4", "3", "2", "1", '0'],
                diamondLevelOption: ['8', '7', '6', '5', '0'],
                strengthLevelRate: ["1", "1.005", "1.013", "1.024", "1.038", "1.055", "1.075", "1.098", "1.124"],
                diamondLevelRate: [0, (32000/27800) *0.195, (32000/27800) *0.390, (32000/27800) *0.585, (32000/27800) *0.780, (32000/27800) *0.975, (32000/27800) *1.170, (32000/27800) *1.755, (32000/27800) *2.6],
                hat: this.buildBaseEquipObject(),
                jacket: this.buildBaseEquipObject(),
                belt: this.buildBaseEquipObject(),
                wrist: this.buildBaseEquipObject(),
                bottoms: this.buildBaseEquipObject(),
                shoes: this.buildBaseEquipObject(),
                necklace: this.buildBaseEquipObject(),
                pendant: this.buildBaseEquipObject(),
                ring1: this.buildBaseEquipObject(),
                ring2: this.buildBaseEquipObject(),
                secondaryWeapon: this.buildBaseEquipObject(),
                primaryWeapon: this.buildBaseEquipObject(),
                stone: {
                    stoneTree: [{
                        value: "wait",
                        label: "加载中请稍等"
                    }],
                    strengthLevel: 0,
                    value: null,
                    stoneKey: null
                },
                attribute: {
                    atMaxLifeBase: 0,
                    atAgilityBase: 0,
                    atStrengthBase: 0,
                    atVitalityBase: 0,
                    atPhysicsAttackPowerBase: 0,
                    atPhysicsAttackPower: 0,
                    atPhysicsCriticalStrike: 0,
                    atPhysicsCriticalStrikeBaseRate: 0,
                    atPhysicsCriticalDamagePowerBase: 0,
                    atPhysicsCriticalDamagePowerBaseKiloNumRate: 175.00,
                    atPhysicsOvercomeBase: 0,
                    atPhysicsOvercomePercent: 0,
                    atStrainBase: 0,
                    atHasteBase: 0,
                    atPVXAllRound: 0,
                    atStrainRate: 0,
                    atMeleeWeaponDamageBase: 0,
                    atMeleeWeaponDamageRand: 0,
                    atSurplusValueBase: 0,
                },
                finalAttribute: {
                    atMaxLifeBase: 0,
                    atAgilityBase: 0,
                    atStrengthBase: 0,
                    atVitalityBase: 0,
                    atPhysicsAttackPowerBase: 0,
                    atPhysicsAttackPower: 0,
                    atPhysicsCriticalStrike: 0,
                    atPhysicsCriticalStrikeBaseRate: 0,
                    atPhysicsCriticalDamagePowerBase: 0,
                    atPhysicsCriticalDamagePowerBaseKiloNumRate: 175.00,
                    atPhysicsOvercomeBase: 0,
                    atPhysicsOvercomePercent: 0,
                    atStrainBase: 0,
                    atHasteBase: 0,
                    atPVXAllRound: 0,
                    atStrainRate: 0,
                    atMeleeWeaponDamageBase: 0,
                    atMeleeWeaponDamageRand: 0,
                    atSurplusValueBase: 0,
                },
                dps: {
                    dpsOld: 0,
                    dpsNew: 0
                },
                utils: {
                    diamondLevelOption: ['8', '7', '6', '5', '0'],
                    diamondLevel: '8',
                    strengthLevelOption: ["6", "5", "4", "3", "2", "1", '0'],
                    strengthLevel: '6',
                    autoComputeCheck: true,
                    autoContrast: false,
                    filter: {
                        minLevel: 20500,
                        maxLevel: 26500,
                        // 在Constant里配置，这里修改配置无效
                        // 用户选择
                        userSelectLevel: [20500, 26300],
                        userSelectLevelKey: "0",
                        pvx: true,
                        pve: true,
                        pvp: false,
                    }
                },
                show:{
                    showSTX : false,
                    showFTX : false,
                }
            }
        }
    },
    methods: {
        // 创建基础装备对象
        buildBaseEquipObject() {
            return {
                id: null,
                value: [],
                // select: [{ id: "wait", name: "加载中请稍后", level: 10000 }],
                strengthLevel: 6,
                enchant1: {
                    id: null,
                    value: null,
                    select: []
                },
                enchant2: {
                    id: null,
                    value: null,
                    select: []
                }
            }
        },
        async buildComputeDpsArgsForPz() {
            var req = (await this.$parent.buildComputeDpsArgs());
            var enchant1List = [
                this.peiZhuang.hat.enchant1.id,
                this.peiZhuang.jacket.enchant1.id,
                this.peiZhuang.belt.enchant1.id,
                this.peiZhuang.wrist.enchant1.id,
                this.peiZhuang.bottoms.enchant1.id,
                this.peiZhuang.shoes.enchant1.id,
                this.peiZhuang.necklace.enchant1.id,
                this.peiZhuang.pendant.enchant1.id,
                this.peiZhuang.ring1.enchant1.id,
                this.peiZhuang.ring2.enchant1.id,
                this.peiZhuang.secondaryWeapon.enchant1.id,
                this.peiZhuang.primaryWeapon.enchant1.id,
            ]
            // 要让附魔排在第一个 否则顺序会出错 感觉这个有问题啊 要优化一下
            req.playerReqDto.enchant1List.forEach(t => enchant1List.push(t));
            req.playerReqDto.enchant1List = enchant1List;

            req.playerReqDto.enchant2List = [
                this.peiZhuang.hat.enchant2.id,
                this.peiZhuang.jacket.enchant2.id,
                this.peiZhuang.belt.enchant2.id,
                this.peiZhuang.wrist.enchant2.id,
                this.peiZhuang.shoes.enchant2.id,
            ];

            req.playerReqDto.pzEquipmentReqDtoList = [
                {
                    equipmentId: this.peiZhuang.hat.id,
                    strengthLevel: this.peiZhuang.hat.strengthLevel,
                    diamondLevel1: this.peiZhuang.hat.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.hat.value.equipOptionDiamondAttributeVoList[0] == null ? 0 : this.peiZhuang.hat.value.equipOptionDiamondAttributeVoList[0].diamondLevel,
                    diamondLevel2: this.peiZhuang.hat.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.hat.value.equipOptionDiamondAttributeVoList[1] == null ? 0 : this.peiZhuang.hat.value.equipOptionDiamondAttributeVoList[1].diamondLevel,
                },
                {
                    equipmentId: this.peiZhuang.jacket.id,
                    strengthLevel: this.peiZhuang.jacket.strengthLevel,
                    diamondLevel1: this.peiZhuang.jacket.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.jacket.value.equipOptionDiamondAttributeVoList[0] == null ? 0 : this.peiZhuang.jacket.value.equipOptionDiamondAttributeVoList[0].diamondLevel,
                    diamondLevel2: this.peiZhuang.jacket.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.jacket.value.equipOptionDiamondAttributeVoList[1] == null ? 0 : this.peiZhuang.jacket.value.equipOptionDiamondAttributeVoList[1].diamondLevel,
                },
                {
                    equipmentId: this.peiZhuang.belt.id,
                    strengthLevel: this.peiZhuang.belt.strengthLevel,
                    diamondLevel1: this.peiZhuang.belt.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.belt.value.equipOptionDiamondAttributeVoList[0] == null ? 0 : this.peiZhuang.belt.value.equipOptionDiamondAttributeVoList[0].diamondLevel,
                    diamondLevel2: this.peiZhuang.belt.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.belt.value.equipOptionDiamondAttributeVoList[1] == null ? 0 : this.peiZhuang.belt.value.equipOptionDiamondAttributeVoList[1].diamondLevel,
                },
                {
                    equipmentId: this.peiZhuang.wrist.id,
                    strengthLevel: this.peiZhuang.wrist.strengthLevel,
                    diamondLevel1: this.peiZhuang.wrist.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.wrist.value.equipOptionDiamondAttributeVoList[0] == null ? 0 : this.peiZhuang.wrist.value.equipOptionDiamondAttributeVoList[0].diamondLevel,
                    diamondLevel2: this.peiZhuang.wrist.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.wrist.value.equipOptionDiamondAttributeVoList[1] == null ? 0 : this.peiZhuang.wrist.value.equipOptionDiamondAttributeVoList[1].diamondLevel,
                },
                {
                    equipmentId: this.peiZhuang.bottoms.id,
                    strengthLevel: this.peiZhuang.bottoms.strengthLevel,
                    diamondLevel1: this.peiZhuang.bottoms.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.bottoms.value.equipOptionDiamondAttributeVoList[0] == null ? 0 : this.peiZhuang.bottoms.value.equipOptionDiamondAttributeVoList[0].diamondLevel,
                    diamondLevel2: this.peiZhuang.bottoms.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.bottoms.value.equipOptionDiamondAttributeVoList[1] == null ? 0 : this.peiZhuang.bottoms.value.equipOptionDiamondAttributeVoList[1].diamondLevel,
                },
                {
                    equipmentId: this.peiZhuang.shoes.id,
                    strengthLevel: this.peiZhuang.shoes.strengthLevel,
                    diamondLevel1: this.peiZhuang.shoes.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.shoes.value.equipOptionDiamondAttributeVoList[0] == null ? 0 : this.peiZhuang.shoes.value.equipOptionDiamondAttributeVoList[0].diamondLevel,
                    diamondLevel2: this.peiZhuang.shoes.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.shoes.value.equipOptionDiamondAttributeVoList[1] == null ? 0 : this.peiZhuang.shoes.value.equipOptionDiamondAttributeVoList[1].diamondLevel,
                },
                {
                    equipmentId: this.peiZhuang.necklace.id,
                    strengthLevel: this.peiZhuang.necklace.strengthLevel,
                    diamondLevel1: this.peiZhuang.necklace.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.necklace.value.equipOptionDiamondAttributeVoList[0] == null ? 0 : this.peiZhuang.necklace.value.equipOptionDiamondAttributeVoList[0].diamondLevel,
                },
                {
                    equipmentId: this.peiZhuang.pendant.id,
                    strengthLevel: this.peiZhuang.pendant.strengthLevel,
                    diamondLevel1: this.peiZhuang.pendant.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.pendant.value.equipOptionDiamondAttributeVoList[0] == null ? 0 : this.peiZhuang.pendant.value.equipOptionDiamondAttributeVoList[0].diamondLevel,
                },
                {
                    equipmentId: this.peiZhuang.ring1.id,
                    strengthLevel: this.peiZhuang.ring1.strengthLevel,
                },
                {
                    equipmentId: this.peiZhuang.ring2.id,
                    strengthLevel: this.peiZhuang.ring2.strengthLevel,
                },
                {
                    equipmentId: this.peiZhuang.secondaryWeapon.id,
                    strengthLevel: this.peiZhuang.secondaryWeapon.strengthLevel,
                    diamondLevel1: this.peiZhuang.secondaryWeapon.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.secondaryWeapon.value.equipOptionDiamondAttributeVoList[0] == null ? 0 : this.peiZhuang.secondaryWeapon.value.equipOptionDiamondAttributeVoList[0].diamondLevel,
                },
                {
                    equipmentId: this.peiZhuang.primaryWeapon.id,
                    strengthLevel: this.peiZhuang.primaryWeapon.strengthLevel,
                    diamondLevel1: this.peiZhuang.primaryWeapon.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.primaryWeapon.value.equipOptionDiamondAttributeVoList[0] == null ? 0 : this.peiZhuang.primaryWeapon.value.equipOptionDiamondAttributeVoList[0].diamondLevel,
                    diamondLevel2: this.peiZhuang.primaryWeapon.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.primaryWeapon.value.equipOptionDiamondAttributeVoList[1] == null ? 0 : this.peiZhuang.primaryWeapon.value.equipOptionDiamondAttributeVoList[1].diamondLevel,
                    diamondLevel3: this.peiZhuang.primaryWeapon.value.equipOptionDiamondAttributeVoList == null || this.peiZhuang.primaryWeapon.value.equipOptionDiamondAttributeVoList[2] == null ? 0 : this.peiZhuang.primaryWeapon.value.equipOptionDiamondAttributeVoList[2].diamondLevel,
                }
            ];
            req.playerReqDto.stone = this.peiZhuang.stone.value != null ? this.peiZhuang.stone.value.id : null;
            return req;
        },
        // 获取玩家数据
        async getPlayerData(){
            var computeDpsReq = (await buildComputeDpsArgsForPz());
            var playerReq = computeDpsReq.playerReqDto;
            const { data: response } = await dataApi.getPlayerData(playerReq);
            await this.configPlayerData(response.data);
        },
        // 配置玩家数据
        async configPlayerData(playerData){
            this.sectBase.finalAttribute.nEquipScore = playerData.nequipScore.value;
        },
        // 方案 start
        async changeProgramme(selectProgramme) {
            console.log(selectProgramme)
            for (var programme of this.programme.programmeList) {
                if (programme.name == selectProgramme) {
                    copyUtils.copyMatchingFieldsIter(programme.peiZhuang, this.peiZhuang, 'select')
                }
            }
            // await this.peiZhuangInitEquip(this.peiZhuang.primaryWeapon, this.peiZhuang.primaryWeapon.value);
            await this.autoComputePeiZhuangAttribute();
        },
        // 保存方案,加入缓存需要额外操作
        async saveProgramme() {
            for (var programme of this.programme.programmeList) {
                if (programme.name == this.programme.selectProgramme) {
                    programme.peiZhuang = JSON.parse(jsonUtils.toJSONStringExcludes(this.peiZhuang,'select'));
                }
            }
        },
        async openProgrammeAddDialog() {
            let nameList = [];
            for (var programme of this.programme.programmeList) {
                nameList.push(programme.name);
            }
            this.$refs.programmeDialogRef.open(nameList);
        },
        async addProgramme(name) {
            var programme = {
                name: name,
            }
            this.programme.programmeList.push(programme);
            this.programme.selectProgramme = name;
            this.cookiesSave();
        },
        async deleteProgramme() {
            if ("默认方案" == this.programme.selectProgramme) {
                this.$alert("默认方案不允许删除！")
            } else {
                this.programme.programmeList = this.programme.programmeList.filter(
                    t => {
                        return t.name != this.programme.selectProgramme
                    }
                );
                this.programme.selectProgramme = "默认方案";
                this.cookiesSave();
                this.$alert('删除方案成功');
            }
        },
        // 方案 end
        // 装备导入 start
        async openPeiZhuangImportDialog() {
            this.$refs.peiZhuangImportDialogRef.open();
        },
        async onMoHeImportData(req) {
            // 先把五彩石置空
            this.peiZhuang.stone.stoneKey = null;

            await this.peiZhuangInitEquipByReq(req.HAT, this.peiZhuang.hat);
            await this.peiZhuangInitEquipByReq(req.BELT, this.peiZhuang.belt);
            await this.peiZhuangInitEquipByReq(req.SHOES, this.peiZhuang.shoes);
            await this.peiZhuangInitEquipByReq(req.WRIST, this.peiZhuang.wrist);
            await this.peiZhuangInitEquipByReq(req.JACKET, this.peiZhuang.jacket);
            await this.peiZhuangInitEquipByReq(req.RING_1, this.peiZhuang.ring1);
            await this.peiZhuangInitEquipByReq(req.RING_2, this.peiZhuang.ring2);
            await this.peiZhuangInitEquipByReq(req.BOTTOMS, this.peiZhuang.bottoms);
            await this.peiZhuangInitEquipByReq(req.PENDANT, this.peiZhuang.pendant);
            await this.peiZhuangInitEquipByReq(req.NECKLACE, this.peiZhuang.necklace);
            await this.peiZhuangInitEquipByReq(req.PRIMARY_WEAPON, this.peiZhuang.primaryWeapon);
            await this.peiZhuangInitEquipByReq(req.SECONDARY_WEAPON, this.peiZhuang.secondaryWeapon);
            await this.changeLoopByEquip(req.PRIMARY_WEAPON);
            await this.autoComputePeiZhuangAttribute();
        },
        // 装备导入 end



        // 开启配装器 start
        async open() {
            this.peiZhuangDialog = true;
        },
        // 开启配装器 end

        // 初始化对话框 start
        async peiZhuangDialogOpen() {
            await this.changeSect(this.sectProp);
            await this.cookiesRead();
            await this.getStoneTree();
            await this.initAttribute();
            await this.autoComputePeiZhuangAttribute();
            await this.init()
            // if(this.peiZhuang.utils.autoContrast){
            //     await this.contrastAllEquipmentOption();
            // }
        },
        // 初始化对话框 end

        // 清除配装数据
        peiZhuangClear(equip) {
            equip.value = [];
            this.computePeiZhuangAttribute();
            this.autoComputePeiZhuangAttribute();
        },
        // 装备赋值 start
        peiZhuangInitEquip(postion, equip) {
            // 如果镶嵌等级不为空则赋值镶嵌等级
            if (postion.value.equipOptionDiamondAttributeVoList != null && postion.value.equipOptionDiamondAttributeVoList.length > 0) {
                if (postion.value.equipOptionDiamondAttributeVoList[0].diamondLevel != null) {
                    equip.equipOptionDiamondAttributeVoList[0].diamondLevel = postion.value.equipOptionDiamondAttributeVoList[0].diamondLevel;
                }
            }
            if (postion.value.equipOptionDiamondAttributeVoList != null && postion.value.equipOptionDiamondAttributeVoList.length > 1) {
                if (postion.value.equipOptionDiamondAttributeVoList[1].diamondLevel != null) {
                    equip.equipOptionDiamondAttributeVoList[1].diamondLevel = postion.value.equipOptionDiamondAttributeVoList[1].diamondLevel;
                }
            }
            if (postion.value.equipOptionDiamondAttributeVoList != null && postion.value.equipOptionDiamondAttributeVoList.length > 2) {
                if (postion.value.equipOptionDiamondAttributeVoList[2].diamondLevel != null) {
                    equip.equipOptionDiamondAttributeVoList[2].diamondLevel = postion.value.equipOptionDiamondAttributeVoList[2].diamondLevel;
                }
            }
            postion.value = equip;
            // 换装备自动选择最高精炼等级
            // if (postion.strengthLevel > postion.value.maxStrengthLevel) {
            postion.strengthLevel = postion.value.maxStrengthLevel;
            // }
        },
        // 初始化五彩石
        async peiZhuangInitStone(attribute1ID, attribute2ID, attribute3ID, level) {
            await this.getStone(attribute1ID, attribute2ID, attribute3ID, level);
            this.autoComputePeiZhuangAttribute();
        },
        // 根据定义好的请求初始化装备 对应java类 PzEquipmentReqDto
        async peiZhuangInitEquipByReq(req, postion) {
            if (req == null || req.id == null) {
                copyUtils.copyMatchingFieldsIter(this.buildBaseEquipObject(), postion);
                return;
            }
            var equipValue = null;
            for (var equip of postion.select) {
                if (req.id.includes(equip.id)) {
                    postion.id = equip.id;
                    equipValue = equip;
                }
            }
            if (equipValue == null) {
                copyUtils.copyMatchingFieldsIter(this.buildBaseEquipObject(), postion);
                return;
            }


            // 装备和属性赋值
            postion.value = equipValue;
            // 精炼等级赋值
            postion.strengthLevel = req.strength;
            // 镶嵌等级赋值
            for (var i = 0; i < req.embedding.length; i++) {
                postion.value.equipOptionDiamondAttributeVoList[i].diamondLevel = req.embedding[i];
            }
            // 小附魔赋值
            // 先清空小附魔
            postion.enchant1.id = null;
            postion.enchant1.value = null;
            for (var enchant1 of postion.enchant1.select) {
                if (enchant1.id == req.enhance) {
                    postion.enchant1.id = enchant1.id;
                    postion.enchant1.value = enchant1;
                }
            }
            // 大附魔赋值
            // 先清空大附魔
            postion.enchant2.id = null;
            postion.enchant2.value = null;
            if (postion.enchant2 != null) {
                for (var enchant2 of postion.enchant2.select) {
                    if (enchant2.id == req.enchant) {
                        postion.enchant2.id = enchant2.id;
                        postion.enchant2.value = enchant2;
                    }
                }
            }
            // 五彩石赋值
            if (req.stone != null && req.stone != "") {
                await this.getStoneById(req.stone);
            }
        },
        async changeLoopByEquip(equip) {
            // 更换装备对应循环判断
            if (equip != null && this.sectImpl.loop.equipLoopMap.get(parseInt(equip.id))) {
                for (var loop of this.sectImpl.loop.loopTypeOptions) {
                    if (loop.code == this.sectImpl.loop.equipLoopMap.get(parseInt(equip.id))) {
                        for (var equipOption of this.peiZhuang.primaryWeapon.select) {
                            if (equipOption.id == parseInt(equip.id)) {
                                this.$alert("检测到选择了具备特殊循环的武器[" + equipOption.name + "],已自动切换循环至[" + loop.name + "]")
                            }
                        }
                        this.$parent.loop.extraPointList = loop.extraPointList;
                        this.$parent.loop.loopType = this.sectImpl.loop.equipLoopMap.get(parseInt(equip.id));
                        return;
                    }
                }
            }
            this.$parent.loop.extraPointList = this.sectImpl.loop.loopTypeOptions[0].extraPointList;
            this.$parent.loop.loopType = this.sectImpl.loop.loopTypeOptions[0].code;
        },

        // 装备赋值 end

        // 获取装备下拉选项 start
        // 对比所有装备dps
        async contrastAllEquipmentOption() {
            this.contrastHatDps();
            this.contrastJacketDps();
            this.contrastBeltDps();
            this.contrastWristDps();
            this.contrastBottomsDps();
            this.contrastShoesDps();
            this.contrastNecklaceDps();
            this.contrastPendantDps();
            this.contrastRing1Dps();
            this.contrastRing2Dps();
            this.contrastSecondaryWeaponDps();
            this.contrastPrimaryWeaponDps();
        },
        // 对比装备dps start
        async contrastEquipDps(subType, select, serial) {
            select = select.filter(item => this.filterEquip(item));
            let idList = select.map(t => t.id);
            let idListArray = [];

            // 过滤掉不符合标准的

            // 分页长度
            let size = 10;
            while (idList.length > 0) {
                idListArray.push(idList.splice(0, size));
            }

            for (let idListItem of idListArray) {
                let weaponSubtype = [0, 1];
                let armorSubtype = [3, 2, 6, 10, 8, 9];
                let trinketSubtype = [4, 7, 5];
                let contrastResult;
                if (weaponSubtype.includes(subType)) {
                    const { data: response } = await this.contrastWeaponOption(subType, idListItem);
                    contrastResult = response.data
                }
                if (armorSubtype.includes(subType)) {
                    const { data: response } = await this.contrastArmorOption(subType, idListItem);
                    contrastResult = response.data
                }
                if (trinketSubtype.includes(subType)) {
                    const { data: response } = await this.contrastTrinketOption(subType, idListItem, serial);
                    contrastResult = response.data
                }

                for (var equip of select) {
                    for (var equipAdd of contrastResult) {
                        if (equip.id == equipAdd.id) {
                            equip.damageAddition = equipAdd.damageAddition;
                        }
                    }
                }
            }
        },
        async contrastHatDps() {
            this.contrastEquipDps(3, this.peiZhuang.hat.select);
        },
        async contrastJacketDps() {
            this.contrastEquipDps(2, this.peiZhuang.jacket.select);
        },
        async contrastBeltDps() {
            this.contrastEquipDps(6, this.peiZhuang.belt.select);
        },
        async contrastWristDps() {
            this.contrastEquipDps(10, this.peiZhuang.wrist.select);
        },
        async contrastBottomsDps() {
            this.contrastEquipDps(8, this.peiZhuang.bottoms.select);
        },
        async contrastShoesDps() {
            this.contrastEquipDps(9, this.peiZhuang.shoes.select);
        },
        async contrastNecklaceDps() {
            this.contrastEquipDps(4, this.peiZhuang.necklace.select);
        },
        async contrastPendantDps() {
            this.contrastEquipDps(7, this.peiZhuang.pendant.select);
        },
        async contrastRing1Dps() {
            this.contrastEquipDps(5, this.peiZhuang.ring1.select);
        },
        async contrastRing2Dps() {
            this.contrastEquipDps(5, this.peiZhuang.ring2.select, 9);

        },
        async contrastSecondaryWeaponDps() {
            this.contrastEquipDps(1, this.peiZhuang.secondaryWeapon.select, 9);
        },
        async contrastPrimaryWeaponDps() {
            this.contrastEquipDps(0, this.peiZhuang.primaryWeapon.select, 9);
        },
        async contrastArmorOption(subType, equipIdList) {
            let req = {
                equipIdList: equipIdList,
                position: subType,
                computeReqDto: this.peiZhuang.utils.autoContrast ? await this.buildComputeDpsArgsForPz() : null
            };
            return await this.$http.post("/peiZhuang/contrastArmorDps", req);
        },
        async contrastTrinketOption(subType, equipIdList, serial) {
            let req = {
                equipIdList: equipIdList,
                position: subType,
                serial: serial,
                computeReqDto: this.peiZhuang.utils.autoContrast ? await this.buildComputeDpsArgsForPz() : null
            };
            return await this.$http.post("/peiZhuang/contrastTrinketDps", req);
        },
        async contrastWeaponOption(subType, equipIdList) {
            let req = {
                equipIdList: equipIdList,
                position: subType,
                computeReqDto: this.peiZhuang.utils.autoContrast ? await this.buildComputeDpsArgsForPz() : null
            };
            return await this.$http.post("/peiZhuang/contrastWeaponDps", req);
        },
        // 对比装备dps end

        // 获取装备下拉选项 end





        // 获取附魔 start
        // 对比附魔dps
        async contrastEnchantDps(position, subType, select, serial) {
            let idList = select.map(t => t.id);
            let idListArray = [];

            let size = 10;
            while (idList.length > 0) {
                idListArray.push(idList.splice(0, size));
            }

            for (let idListItem of idListArray) {
                const { data: response } = await this.contrastEnchantOption(position, subType, idListItem, serial);
                var contrastResult = response.data;

                for (var enchant of select) {
                    for (var enchantAdd of contrastResult) {
                        if (enchant.id == enchantAdd.id) {
                            enchant.damageAddition = enchantAdd.damageAddition;
                        }
                    }
                }
            }
        },
        async getAllenchantOption() {
            this.getHatEnchantOption();
            this.getJacketEnchantOption();
            this.getBeltEnchantOption();
            this.getWristEnchantOption();
            this.getButtomsEnchantOption();
            this.getShoesEnchantOption();
            this.getNecklaceEnchantOption();
            this.getPendantEnchantOption();
            this.getRing1EnchantOption();
            this.getRing2EnchantOption();
            this.getSecondaryWeaponEnchantOption();
            this.getPrimaryWeaponEnchantOption();
        },
        async contrastHatEnhanceDps() {
            this.contrastEnchantDps(3, 1, this.peiZhuang.hat.enchant1.select);
        },
        async contrastHatEnchantDps() {
            this.contrastEnchantDps(3, 2, this.peiZhuang.hat.enchant2.select);
        },
        async contrastJacketEnhanceDps() {
            this.contrastEnchantDps(2, 1, this.peiZhuang.jacket.enchant1.select);
        },
        async contrastJacketEnchantDps() {
            this.contrastEnchantDps(2, 2, this.peiZhuang.jacket.enchant2.select);
        },
        async contrastBeltEnhanceDps() {
            this.contrastEnchantDps(6, 1, this.peiZhuang.belt.enchant1.select);
        },
        async contrastBeltEnchantDps() {
            this.contrastEnchantDps(6, 2, this.peiZhuang.belt.enchant2.select);
        },
        async contrastWristEnhanceDps() {
            this.contrastEnchantDps(10, 1, this.peiZhuang.wrist.enchant1.select);
        },
        async contrastWristEnchantDps() {
            this.contrastEnchantDps(10, 2, this.peiZhuang.wrist.enchant2.select);
        },
        async contrastBottomsEnhanceDps() {
            this.contrastEnchantDps(8, 1, this.peiZhuang.bottoms.enchant1.select);
        },
        async contrastShoesEnhanceDps() {
            this.contrastEnchantDps(9, 1, this.peiZhuang.shoes.enchant1.select);
        },
        async contrastShoesEnchantDps() {
            this.contrastEnchantDps(9, 2, this.peiZhuang.shoes.enchant2.select);
        },
        async contrastNecklaceEnhanceDps() {
            this.contrastEnchantDps(4, 1, this.peiZhuang.necklace.enchant1.select);
        },
        async contrastPendantEnhanceDps() {
            this.contrastEnchantDps(7, 1, this.peiZhuang.pendant.enchant1.select);
        },
        async contrastRing1EnhanceDps() {
            this.contrastEnchantDps(5, 1, this.peiZhuang.ring1.enchant1.select, 8);
        },
        async contrastRing2EnhanceDps() {
            this.contrastEnchantDps(5, 1, this.peiZhuang.ring2.enchant1.select, 9);
        },
        async contrastSecondaryWeaponEnhanceDps() {
            this.contrastEnchantDps(1, 1, this.peiZhuang.secondaryWeapon.enchant1.select);
        },
        async contrastPrimaryWeaponEnhanceDps() {
            this.contrastEnchantDps(0, 1, this.peiZhuang.primaryWeapon.enchant1.select);
        },
        async contrastEnchantOption(position, subType, enchantIdList, serial) {
            let req = {
                position: position,
                subType: subType,
                enchantIdList: enchantIdList,
                serial: serial,
                computeReqDto: this.peiZhuang.utils.autoContrast ? await this.buildComputeDpsArgsForPz() : null
            };
            return await this.$http.post("/peiZhuang/contrastEnchantDps", req);
        },
        // 获取附魔 end

        // 获取五彩石 start
        async getStoneTree() {
            let req = {};
            const { data: response } = await this.$http.post("/peiZhuang/getStoneTree", req);
            this.peiZhuang.stone.stoneTree = response.data;
        },
        async getStone(attribute1ID, attribute2ID, attribute3ID, level) {
            let req = {
                attribute1ID: attribute1ID,
                attribute2ID: attribute2ID,
                attribute3ID: attribute3ID,
                level: level
            };
            const { data: response } = await this.$http.post("/peiZhuang/getStone", req);
            this.peiZhuang.stone.value = response.data;
        },
        async getStoneById(id) {
            let req = {
                params: {
                    id: id
                }
            };
            const { data: response } = await this.$http.get("/peiZhuang/getStoneById", req);
            var data = response.data;
            this.peiZhuang.stone.stoneKey = [];
            this.peiZhuang.stone.stoneKey.push(data.attribute1ID);
            this.peiZhuang.stone.stoneKey.push(data.attribute2ID);
            this.peiZhuang.stone.stoneKey.push(data.attribute3ID);
            this.peiZhuang.stone.stoneKey.push(data.level);
            this.peiZhuang.stone.id = id;
            await this.peiZhuangInitStone(data.attribute1ID, data.attribute2ID, data.attribute3ID, data.level);
        },
        // 获取五彩石 end

        // 计算属性 start
        // 自动计算
        async autoComputePeiZhuangAttribute() {
            this.computePeiZhuangAttribute()
            if (this.peiZhuang.utils.autoComputeCheck) {
                // 计算 dps
                await this.computePeiZhuangDps();
            }else{
                await this.getPlayerData();
            }
            // 判断是否展示特效
            this.showAllTX();
        
            
            // 保存cookie
            this.cookiesSave();
        },
        // 手动计算
        async manualComputePeiZhuangAttribute() {
            await this.computePeiZhuangAttribute()
            // 计算 dps
            await this.computePeiZhuangDps();
            // 保存cookie
            this.cookiesSave();
        },
        async computePeiZhuangAttribute() {
            console.log(new Date().getTime());
            await this.initAttribute();
            console.log(new Date().getTime());
            // 计算帽子
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.hat);
            // 计算上衣
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.jacket);
            // 计算腰带
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.belt);
            // 计算护腕
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.wrist);
            // 计算裤子
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.bottoms);
            // 计算鞋子
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.shoes);
            // 计算项链
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.necklace);
            // 计算腰坠
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.pendant);
            // 计算戒指1
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.ring1);
            // 计算戒指2
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.ring2);
            // 计算暗器
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.secondaryWeapon);
            // 计算武器
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.primaryWeapon);
            // 计算五彩石
            this.computePeiZhuangAttributeBYEquip(this.peiZhuang.stone);

            // 计算最终属性
            this.computeFinalAttribute();
            console.log(this.sectBase.peiZhuang.specialEffects.equipSkill);
        },

        // 计算配装器DPS start
        async computePeiZhuangDps() {


            const response = await this.$parent.computeDps(await this.buildComputeDpsArgsForPz());
            // 赋值玩家数据
            await this.configPlayerData(response.sect)

            // 尝试在打开页面时候 触发刷新dps的操作
            // 是由于字段类型导致 和赋值方式无关 但是这种方式值得参考
            this.$set(this.peiZhuang.dps, "dpsOld", parseInt(this.peiZhuang.dps.dpsNew))
            this.$set(this.peiZhuang.dps, "dpsNew", parseInt(response.dps.toFixed(0)))
            // this.peiZhuang.dps.dpsOld = this.peiZhuang.dps.dpsNew;
            // this.peiZhuang.dps.dpsNew = response.dps.toFixed(0);
        },
        // 计算配装器DPS end
        // 配装工具 start
        async autoDiamond() {
            var diamondLevel = this.peiZhuang.utils.diamondLevel;
            this.setEquipDiamondLevel(this.peiZhuang.hat, diamondLevel);
            this.setEquipDiamondLevel(this.peiZhuang.jacket, diamondLevel);
            this.setEquipDiamondLevel(this.peiZhuang.belt, diamondLevel);
            this.setEquipDiamondLevel(this.peiZhuang.wrist, diamondLevel);
            this.setEquipDiamondLevel(this.peiZhuang.bottoms, diamondLevel);
            this.setEquipDiamondLevel(this.peiZhuang.shoes, diamondLevel);
            this.setEquipDiamondLevel(this.peiZhuang.necklace, diamondLevel);
            this.setEquipDiamondLevel(this.peiZhuang.pendant, diamondLevel);
            this.setEquipDiamondLevel(this.peiZhuang.ring1, diamondLevel);
            this.setEquipDiamondLevel(this.peiZhuang.ring2, diamondLevel);
            this.setEquipDiamondLevel(this.peiZhuang.secondaryWeapon, diamondLevel);
            this.setEquipDiamondLevel(this.peiZhuang.primaryWeapon, diamondLevel);
            this.autoComputePeiZhuangAttribute();
        },
        async setEquipDiamondLevel(equip, diamondLevel) {
            var diamondList = equip.value.equipOptionDiamondAttributeVoList;
            if (diamondList != null && diamondList.length > 0) {
                for (var diamond of diamondList) {
                    diamond.diamondLevel = diamondLevel;
                }
            }
        },
        async autoStrength() {
            var strengthLevel = this.peiZhuang.utils.strengthLevel;
            this.setEquipStrengthLevel(this.peiZhuang.hat, strengthLevel);
            this.setEquipStrengthLevel(this.peiZhuang.jacket, strengthLevel);
            this.setEquipStrengthLevel(this.peiZhuang.belt, strengthLevel);
            this.setEquipStrengthLevel(this.peiZhuang.wrist, strengthLevel);
            this.setEquipStrengthLevel(this.peiZhuang.bottoms, strengthLevel);
            this.setEquipStrengthLevel(this.peiZhuang.shoes, strengthLevel);
            this.setEquipStrengthLevel(this.peiZhuang.necklace, strengthLevel);
            this.setEquipStrengthLevel(this.peiZhuang.pendant, strengthLevel);
            this.setEquipStrengthLevel(this.peiZhuang.ring1, strengthLevel);
            this.setEquipStrengthLevel(this.peiZhuang.ring2, strengthLevel);
            this.setEquipStrengthLevel(this.peiZhuang.secondaryWeapon, strengthLevel);
            this.setEquipStrengthLevel(this.peiZhuang.primaryWeapon, strengthLevel);

            this.autoComputePeiZhuangAttribute();
        },
        async setEquipStrengthLevel(equip, strengthLevel) {
            var maxStrengthLevel = equip.value.maxStrengthLevel;
            if (strengthLevel > maxStrengthLevel) {
                equip.strengthLevel = maxStrengthLevel;
            } else {
                equip.strengthLevel = strengthLevel;
            }
        },
        // 推荐装备
        async recommendPeiZhuang() {
            // 获取配装DPS数值
            var peizhuangDps = JSON.parse(JSON.stringify(this.peiZhuang.dps));
            // 获取配装工具状态
            var peizhuangUtils = JSON.parse(JSON.stringify(this.peiZhuang.utils));
            // 获取配装装备数值（不包含select属性）
            copyUtils.copyMatchingFieldsIter(this.data.recommendPeiZhuang, this.peiZhuang, 'select')

            // 换推荐配装不置换工具状态
            this.peiZhuang.utils = peizhuangUtils;

            await this.autoComputePeiZhuangAttribute();
            // 临时补丁 当自动计算时才会刷新dps
            if (this.peiZhuang.utils.autoComputeCheck) {
                this.peiZhuang.dps.dpsOld = peizhuangDps.dpsNew;
            } else {
                this.peiZhuang.dps.dpsOld = peizhuangDps.dpsOld;
                this.peiZhuang.dps.dpsNew = peizhuangDps.dpsNew;
            }
        },
        // 配装工具 end
        async initAttribute() {
            await this.initSectAttribute();
            this.sectBase.currentAttribute;
            this.sectBase.peiZhuang.specialEffects.setMap = new Map();
            this.sectBase.peiZhuang.specialEffects.atSetEquipmentRecipe = [];
            this.sectBase.peiZhuang.specialEffects.equipSkill = [];
            this.sectBase.peiZhuang.specialEffects.atSkillEventHandler = [];
        },
        // 需要给用户可选装备等级，因此要过滤掉一些装备
        filterEquip(equip) {
            // 如果不符合品级要求返回false
            if(equip.level < this.peiZhuang.utils.filter.userSelectLevel[0] || equip.level > this.peiZhuang.utils.filter.userSelectLevel[1]){
                return false;
            }
            // 如果不符合用途规则（pvp、pve、pvx）则返回false
            // 当装备为1（pve）时，如果不选择pve则返回false
            // 当装备为2（pvp）时，如果不选择pvp则返回false
            // 当装备为3（pvx）时，如果不选择pvx则返回false
            if((equip.pvType == 1 && !this.peiZhuang.utils.filter.pve)){
                return false;
            }
            if((equip.pvType == 2 && !this.peiZhuang.utils.filter.pvp)){
                return false;
            }
            if((equip.pvType == 3 && !this.peiZhuang.utils.filter.pvx)){
                return false;
            }

            return true;
        },
        cookiesSave() {
            // 保存操作前先保存方案
            this.saveProgramme();
            // 暂时只提供给凌雪阁和凌雪阁悟，配装装备共享
            var prefix = 'lxg';
            localStorage.setItem(prefix + ':programme', JSON.stringify(this.programme));
            localStorage.setItem(prefix + ':peiZhuang', jsonUtils.toJSONStringExcludes(this.peiZhuang, 'select'));
        },
        cookiesRead() {
            // 暂时只提供给凌雪阁和凌雪阁悟，配装装备共享
            // var prefix = this.sectProp;
            var prefix = 'lxg';
            var programme = localStorage.getItem(prefix + ':programme');
            if (programme != null && "undefined" != programme) {
                copyUtils.copyMatchingFieldsIter(JSON.parse(programme), this.programme, "select");
            }
            var peiZhuang = localStorage.getItem(prefix + ':peiZhuang');
            if (peiZhuang != null  && "undefined" != peiZhuang) {
                this.cookieReadPeiZhuang(JSON.parse(peiZhuang));
            }
        },
        cookieReadPeiZhuang(peiZhuang) {
            this.cookieReadPeiZhuangEqiup(peiZhuang.hat, this.peiZhuang.hat);
            this.cookieReadPeiZhuangEqiup(peiZhuang.jacket, this.peiZhuang.jacket);
            this.cookieReadPeiZhuangEqiup(peiZhuang.belt, this.peiZhuang.belt);
            this.cookieReadPeiZhuangEqiup(peiZhuang.wrist, this.peiZhuang.wrist);
            this.cookieReadPeiZhuangEqiup(peiZhuang.bottoms, this.peiZhuang.bottoms);
            this.cookieReadPeiZhuangEqiup(peiZhuang.shoes, this.peiZhuang.shoes);
            this.cookieReadPeiZhuangEqiup(peiZhuang.necklace, this.peiZhuang.necklace);
            this.cookieReadPeiZhuangEqiup(peiZhuang.pendant, this.peiZhuang.pendant);
            this.cookieReadPeiZhuangEqiup(peiZhuang.ring1, this.peiZhuang.ring1);
            this.cookieReadPeiZhuangEqiup(peiZhuang.ring2, this.peiZhuang.ring2);
            this.cookieReadPeiZhuangEqiup(peiZhuang.secondaryWeapon, this.peiZhuang.secondaryWeapon);
            this.cookieReadPeiZhuangEqiup(peiZhuang.primaryWeapon, this.peiZhuang.primaryWeapon);
            this.cookieReadPeiZhuangEqiup(peiZhuang.stone, this.peiZhuang.stone);
            this.cookieReadPeiZhuangEqiup(peiZhuang.attribute, this.sectBase.finalAttribute);
            this.cookieReadPeiZhuangEqiup(peiZhuang.specialEffects, this.sectBase.peiZhuang.specialEffects);
            this.cookieReadPeiZhuangEqiup(peiZhuang.dps, this.peiZhuang.dps);
            this.cookieReadPeiZhuangEqiup(peiZhuang.utils, this.peiZhuang.utils);
        },
        cookieReadPeiZhuangEqiup(equipJson, equip) {
            copyUtils.copyMatchingFieldsIter(equipJson, equip, "select");
        },
        async confrim() {
            this.peiZhuangDialog = false;
            console.log(JSON.stringify(jsonUtils.toJSONExcludes(this.peiZhuang,'select')))
            // 深度拷贝最终数据 并设置攻击力为基础攻击力 
            var confirmData = JSON.parse(JSON.stringify(this.sectBase.finalAttribute));
            confirmData.atPhysicsAttackPowerBase = this.sectBase.currentAttribute.atPhysicsAttackPowerBase;
            this.$emit("confirm", confirmData);
        },
        async init() {
            this.peiZhuang.utils.filter.minLevel = this.constant.peiZhuang.filter.minLevel;
            this.peiZhuang.utils.filter.maxLevel = this.constant.peiZhuang.filter.maxLevel;
            // this.peiZhuang.utils.filter.userSelectLevel = [this.constant.peiZhuang.filter.minLevel, this.constant.peiZhuang.filter.maxLevel];
        },
        async changeFilter() {
            this.peiZhuang.utils.filter.userSelectLevelKey = this.peiZhuang.utils.filter.userSelectLevel[0] + ":" + this.peiZhuang.utils.filter.userSelectLevel[1];
        },
        // 展示所有特效
        async showAllTX(){
            this.showSTX();
            this.showFTX();
        },
        // 展示水特效
        async showSTX() {
            // 遍历技能列表判断是否有符合水特效技能ID的技能
            for (var i = 0; i < this.sectBase.peiZhuang.specialEffects.equipSkill.length; i++) {
                if (this.sectBase.peiZhuang.specialEffects.equipSkill[i].includes(this.constant.shuiTXSkillId)) {
                    this.peiZhuang.show.showSTX =  true;
                    return;
                }
            }
            this.peiZhuang.show.showSTX =  false;
        },
        // 展示特效腰坠
        async showFTX() {
            // 遍历技能列表判断是否有符合水特效技能ID的技能
            for (var i = 0; i < this.sectBase.peiZhuang.specialEffects.equipSkill.length; i++) {
                if (this.sectBase.peiZhuang.specialEffects.equipSkill[i].includes(this.constant.fengTXSkillId)) {
                    this.peiZhuang.show.showFTX =  true;
                    return;
                }
            }
            this.peiZhuang.show.showFTX =  false;
        },
    },

}
</script>

<style lang="less" scoped>
::v-deep .peiZhuangSetLine {
    padding-top: 5px;
    padding-left: 10px;
    float: left;
    height: 40px;
    display: flex;
    width: 100%;
    margin: auto;

    .peiZhuangSetItem {
        width: 50%;
        display: flex;
        text-align: left;

        .peiZhuangSetLabel {
            width: 50%;
            font-size: 15px;
            font-style: normal;
            font-weight: bold;
            color: rgb(0, 0, 0);
        }

        .peiZhuangSetTrueValue {
            width: 50%;
            font-size: 18px;
            font-style: normal;
            font-weight: bold;
            font-family: 宋体;
            color: rgb(15, 116, 14);
        }

        .peiZhuangSetFalseValue {
            width: 50%;
            font-size: 18px;
            font-style: normal;
            font-weight: bold;
            font-family: 宋体;
            color: rgb(211, 36, 36)
        }
    }
}

::v-deep .peiZhuangDpsLine {
    padding-top: 5px;
    padding-left: 10px;
    height: 40px;
    display: flex;
    margin: auto;



    .peiZhuangDpsItem {
        width: 250px;
        display: flex;
        text-align: left;
        margin: auto;



        .peiZhuangDpsLabel {
            width: 60%;
            font-size: 18px;
            font-style: normal;
            font-weight: bold;
            text-align: right;
            color: rgb(0, 0, 0);

        }

        .peiZhuangDpsTrueValue {
            width: 40%;
            font-size: 18px;
            font-style: normal;
            font-weight: bold;
            font-family: 宋体;
            text-align: left;
            color: rgb(211, 36, 36)
        }

        .peiZhuangDpsFalseValue {
            width: 40%;
            font-size: 18px;
            font-style: normal;
            font-weight: bold;
            font-family: 宋体;
            text-align: left;
            color: rgb(15, 116, 14);
        }
    }
}

::v-deep .peiZhuangUtilItem {
    display: flex;
    margin-right: 50px;

    .peiZhuangUtilSelect {
        width: 60px;
        height: 10px;
    }

    .peiZhuangUtilButton {
        color: white;
        text-align: center;
        font-weight: bold;
        font-size: 16px;
        background-color: #000066;
        margin-right: 10px;
        height: 40px;
    }

    .peiZhuangUtilLabel {
        width: 40%;
        font-size: 18px;
        font-style: normal;
        font-weight: bold;
        font-family: 宋体;
        text-align: left;
        color: rgb(211, 36, 36)
    }



}

::v-deep .peiZhuangLine {
    .equipSelect {
        width: 300px;
    }

    .strengthSelect {
        width: 60px;
    }

    .diamondSelect {
        width: 60px;
    }

    .enchantSelect1 {
        width: 180px;
    }

    .enchantSelect2 {
        width: 150px;
    }

    .peiZhuangLabel {
        color: brown;
        margin-left: 10px;
        font-weight: bold;
        font-size: 16px
    }

    box-sizing:border-box;
    padding-top: 5px;
    padding-left: 10px;
    float: left;
    height: 48px;
    width: 100%;
    display: flex;
}



::v-deep .peiZhuangAttributeLine {
    padding-top: 5px;
    padding-left: 10px;
    float: left;
    height: 40px;
    display: flex;
    width: 100%;

    .peiZhuangAttributeItem {
        width: 50%;
        display: flex;
        text-align: left;

        .peiZhuangAttributeLabel {
            width: 45%;
            font-size: 15px;
            font-style: normal;
            font-weight: bold;
            color: rgb(0, 0, 0);
        }

        .peiZhuangAttributeValue {
            width: 55%;
            font-size: 18px;
            font-style: normal;
            font-weight: bold;
            font-family: 宋体;
            color: rgb(1, 1, 109);
        }
    }
}

@media screen and (max-width: 1550px) {
    ::v-deep .peiZhuangDialog {
        transform: scale(0.9);
    }
}

@media screen and (max-width: 1350px) {
    ::v-deep .peiZhuangDialog {
        transform: scale(0.85);
    }
}

/deep/ .peiZhuangDialog {
    .el-dialog__header{
        .el-dialog__title {
            font-size: 25px;
            font-style: normal;
            font-weight: bold;
            color: brown;
        }
    }
    .el-dialog__body{
        padding-top: 0px;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 0px;
        
    }
    .el-dialog__footer{
        margin-bottom: 5px;
        margin-top: 5px;
        width: 100%;
        display: flex;
        justify-content: right;
    }
   border-radius: 20px;
   background-color: rgb(252, 252, 252);
//    background-image: url("@/assets/配装器背景图亮2.jpg");
//    background-size: cover;
}
</style>